import React, { useState } from "react";
import { useNotify, usePermissions, useTranslate } from "react-admin";

import { httpClient } from "../../../api/httpClient";
import { UserRole } from "../../../entities";
import { FileUploader } from "./FileUploader";

interface UploadOldAddressMappingProps {
  terminalId: number;
}

export const UploadOldAddressMapping = ({ terminalId }: UploadOldAddressMappingProps) => {
  const notify = useNotify();
  const translate = useTranslate();
  const { permissions } = usePermissions();
  const [isUploading, setIsUploading] = useState(false);

  const isAdmin = permissions && permissions.role === UserRole.admin;

  const handleUpload = async (file: File) => {
    if (!terminalId) {
      notify("osfc.storage_ui.upload_mapping.select_terminal", "warning");
      return;
    }

    setIsUploading(true);

    try {
      // Read the file content
      const fileContent = await file.text();
      const mapping = JSON.parse(fileContent);

      // Upload the mapping via API
      await httpClient(
        `/storage/terminal/${terminalId}/storage-place-address-mapping`,
        {
          method: 'PUT',
          body: JSON.stringify({ mapping }),
        }
      );

      notify("osfc.storage_ui.upload_mapping.success", "success");
    } catch (error: any) {
      console.error("Upload error:", error);
      notify(error.message || translate("osfc.storage_ui.upload_mapping.failed"), "error");
      throw error;
    } finally {
      setIsUploading(false);
    }
  };

  if (!isAdmin) {
    return null;
  }

  return (
    <FileUploader
      title={translate("osfc.storage_ui.upload_mapping.title")}
      accept=".json"
      actions={[
        {
          label: translate("osfc.storage_ui.upload_mapping.upload_button"),
          onClick: handleUpload,
          color: "primary",
        },
      ]}
      isLoading={isUploading}
      style={{ marginBottom: "15px" }}
      chooseFileButtonText={translate("osfc.storage_ui.upload_mapping.choose_file")}
    />
  );
};
